import React from 'react';
import contacts from '../../data/contacts.json';

const Header = ({ activeTab, darkMode, setDarkMode, cart, setActiveTab, checkoutStep }) => {
  return (
    <header className={`p-4 sticky top-0 z-10 shadow-sm flex justify-between items-center ${darkMode ? 'bg-gray-800' : 'bg-white'
      }`}>
      <div className="flex items-center">
        <img
          src={contacts.logo}
          alt="Автобокс"
          className="h-8 mr-2"
          onClick={() => setActiveTab('selector')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="flex items-center">
        {activeTab === 'cart' && checkoutStep === 1 ? null : (
          <div className="relative mr-4">
            <button
              onClick={() => setActiveTab('cart')}
              className="p-2 rounded-full"
              aria-label={`Корзина${cart.length > 0 ? `, ${cart.length} товаров` : ''}`}
            >
              <i className="fas fa-shopping-cart text-xl" aria-hidden="true"></i>
              {cart.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" aria-hidden="true">
                  {cart.length}
                </span>
              )}
            </button>
          </div>
        )}
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2 rounded-full"
          aria-label={darkMode ? "Переключить на светлую тему" : "Переключить на темную тему"}
        >
          <i className={`fas ${darkMode ? 'fa-sun' : 'fa-moon'} text-xl`} aria-hidden="true"></i>
        </button>
      </div>
    </header>
  );
};

export default Header;